import { SYSTEM_API, TIMEZONE_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { SystemConfigModel, TimezoneModel } from "./system-setting.models";
export const getTimeZones = async () => {
  return await apiClient.getHttp<TimezoneModel[]>(`${TIMEZONE_API}`);
};

export const getSystemConfig = async () => {
  return await apiClient.getHttp<SystemConfigModel>(`${SYSTEM_API}`);
};
export const updateSystemConfig = async (model: SystemConfigModel) => {
  const response = await apiClient.putHttp(`${SYSTEM_API}`, model);
  return response;
};
